import React, { useId, useRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import {
  Typography,
  Card,
  Stack,
  Box,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  ButtonBase,
  Popover, 
} from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import SignUpBackground from "src/public/assets/illustrations/signupBackground.png";
import LeftSideImage from "src/public/assets/illustrations/leftSide.png";
import RightSideImage from "src/public/assets/illustrations/rightSide.svg";
import InputField from './components/desktop/InputField.js'
import SignUpForm from "./components/desktop/SignUpForm.js";
import Loading from "./components/desktop/Loading.js"
import Complete from "./components/desktop/Complete.js"



const StyledRoot = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  width: "100%",
  fontFamily: "'Lato', sans-serif",
  paddingBottom: "156px",
  paddingTop: "113px",
  backgroundColor: "#E6F3F7",
});

export default function SignupDesktop({handleSubmit,
submitTick,
errors,
setErrors,
validate,
showErrors,
setShowErrors,
firstName,
setFirstName,
lastName,
setLastName,
email,
setEmail,
password,
setPassword,
confirmPassword,
setConfirmPassword,
handleFirstNameChange,
handleLastNameChange,
handleEmailChange,
handlePasswordChange,
handleConfirmPasswordChange,
showPassword,
setShowPassword,
showConfirmPassword,
setShowConfirmPassword,
handleTogglePassword,
handleToggleConfirmPassword, termsAccepted, 
setTermsAccepted, handleTermsAcceptedChange, 
loading,
complete

}) {






    const auth0LoginUrl =
  "https://dev-4m53d4wv8p6pmod8.us.auth0.com/u/login";


    const handleSignIn = () => {
    window.location.href = auth0LoginUrl;
  };






  






  return (
    <>
      <Helmet>
        <title>SignUp | NanoNotify.io</title>
        <link
          href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <StyledRoot>
        <Stack
          direction="column"
          spacing={0}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Stack
            alignItems="center"
            spacing={0.5} // Optional spacing between elements
            sx={{ marginBottom: "32px", width: "100%" }}
          >
            <Typography
              gutterBottom
              sx={{
                fontFamily: "'Lato', sans-serif",
                textAlign: "center",
                fontWeight: 900,
                fontSize: 42,
                color: "#395465",
                letterSpacing: "-0.03em",
                pr: 4,
              }}
            >
          { complete ? "You’re all set!"  :   "Get Started With NanoNotify" }
            </Typography>
            <Typography
              gutterBottom
              sx={{
                fontFamily: "'Lato', sans-serif",
                textAlign: "center",
                fontWeight: 500,
                fontSize: 18,
                color: "#49768C",
                letterSpacing: "-0.03em",
                pr: 4,
              }}
            >
              {complete ? 
              "Your account has been created. Check your email and verify your account"
              :
              "Try us out for free and see how easy we make updating your customers"
              }
              
            </Typography>
          </Stack>

          <Stack direction="row" spacing={0} sx={{ justifyContent: "center" }}>
            <Box sx={{ display: "block", height: "558px", mt: 6.5, mr: -3 }}>
              <img src={LeftSideImage} alt="" style={{ height: "510px" }} />
            </Box>
            <Card
              sx={{
                fontFamily: "'Lato', sans-serif",
                margin: "auto",
                mt: 1,
                padding: "40px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: `2px solid #DBEBF6`,
                borderRadius: "25px",
                background: "#FFFFFF",
                zIndex: 2,
                height: "558px",
                minWidth: "600px",
                boxShadow: "6px 19px 19.1px 0px rgba(94, 158, 188, 0.35)",
                mb: -2,
                mx: -17,
              }}
            >
              {/* Form State */}
{
  loading ? (
    <Loading />
  ) : complete ? (
    <Complete />
  ) : (
    <SignUpForm
      handleSubmit={handleSubmit}
      submitTick={submitTick}
      errors={errors}
      setErrors={setErrors}
      validate={validate}
      showErrors={showErrors}
      setShowErrors={setShowErrors}
      firstName={firstName}
      setFirstName={setFirstName}
      lastName={lastName}
      setLastName={setLastName}
      email={email}
      setEmail={setEmail}
      password={password}
      setPassword={setPassword}
      confirmPassword={confirmPassword}
      setConfirmPassword={setConfirmPassword}
      handleFirstNameChange={handleFirstNameChange}
      handleLastNameChange={handleLastNameChange}
      handleEmailChange={handleEmailChange}
      handlePasswordChange={handlePasswordChange}
      handleConfirmPasswordChange={handleConfirmPasswordChange}
      showPassword={showPassword}
      setShowPassword={setShowPassword}
      showConfirmPassword={showConfirmPassword}
      setShowConfirmPassword={setShowConfirmPassword}
      handleTogglePassword={handleTogglePassword}
      handleToggleConfirmPassword={handleToggleConfirmPassword}
      handleTermsAcceptedChange={handleTermsAcceptedChange}
      termsAccepted={termsAccepted}
      setTermsAccepted={setTermsAccepted}
    />
  )
}


            {/* Loading State */}


             {/* Success State */}

            </Card>
            <Box sx={{ display: "block", height: "600px", mt: -1 }}>
              <img src={RightSideImage} alt="" style={{ height: "560px" }} />
            </Box>
          </Stack>
        </Stack>
      </StyledRoot>
    </>
  );
}
